import api from '../config/api'
// import { Button } from '@material-ui/core'
import PropTypes from 'prop-types'
import { createContext, useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { authService } from '../services/authService'
import { authServiceIFI } from '../services/authServiceIFI'
// import { validateToken } from '../services/Forms/post'
import {
  LoginBack,
  ValidateTokenMipyme,
  ValidateStatusUser,
} from '../services/Authentication'
import swal from 'sweetalert'
import Swal from 'sweetalert2'
import config from './../config/config.json'
import { validateEditForm } from '../services/Forms/create'
import { postAuthenticated } from '../config/apiSinToken'
const AuthContext = createContext()

export const AuthContextProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [userName, setUserName] = useState('')
  const [userFullName, setUserFullName] = useState('')
  const [userCompanyID, setUserCompanyID] = useState('')
  const [userCompanyName, setUserCompanyName] = useState('')
  const [userCompanyType, setUserCompanyType] = useState('')
  const [userCountry, setUserCountry] = useState('')
  const [userToken, setUserToken] = useState('')
  const [userID, setUserID] = useState('')
  const [userIDB2C, setUserID2C] = useState('')
  const [IdIFIToken, setIdIFIToken] = useState()
  const [isAuthBackend, setisAuthBackend] = useState(false)

  const [UserRoles, setUserRoles] = useState([])
  const [TokenBack, setTokenBack] = useState([])
  // const [canReadAllProjects, setCanReadAllProjects] = useState()
  const [setOpenFake] = useState(false)
  // search
  const { search, pathname } = useLocation()

  // const stateQueryParam = new URLSearchParams(search).get('state')
  // const isLoginCallback = !!stateQueryParam
  const stateQueryParamAT = new URLSearchParams(search).get('accessToken')
  const TokenIFI = window.location.href.split('#id_token=')

  // const stateQueryParamAT =
  //   'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImN0eSI6IkpXVCJ9.eyJSb2xlIjoiTWlQeW1lIiwiaWRVc2VyQXp1cmVCMkMiOiI0MTljMDA0MS1kN2M5LTQ0NTUtODAxMC1mMDgyN2JjMDc4NjIiLCJ1c2VyTmFtZSI6IlBsYW50YXMgU2lsIFNpbHZlc3RyZXMiLCJ1c2VyRnVsbE5hbWUiOiJQbGFudGFzIFNpbCBTaWx2ZXN0cmVzIiwiY29tcGFueUlkIjoiMTIzMTIzMTIzMTIzMjMyIiwiY29tcGFueU5hbWUiOiJQbGFudHMgdHJlZXMgU2lsIiwiY29tcGFueVR5cGUiOiIzIiwiaWRDb3VudHJ5IjoiNSIsIm5iZiI6MTY2MDY3OTE3MiwiZXhwIjoxNjYwNjgyNzcyLCJpYXQiOjE2NjA2NzkxNzIsImlzcyI6Imh0dHA6Ly9teXNpdGUuY29tIiwiYXVkIjoiaHR0cDovL215YXVkaWVuY2UuY29tIn0.yt3vHHotbHTatErqh_vpXj3EZeKenHqhYCvoA5K2LqQ'

  useEffect(async () => {
    api.ChangeUserToken(userToken)
  }, [userToken])

  // const validateForm = async () => {
  //   try {
  //     const response = await validateEditForm(userIDB2C, 4, 0)
  //     if (response.Success) {
  //       console.log('Desbloqueo exitoso')
  //     }
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  const prueba = async () => {
    try {
      const response = await postAuthenticated()
      console.log('el response', response)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    prueba()
  }, [])

  useEffect(async () => {
    if (userIDB2C !== '') validateEditForm(userIDB2C, 3, 0)
  }, [userIDB2C])

  const urlfront = config.URLFrontend
  const getAuth = async (Email, User) => {
    try {
      const response = await LoginBack(Email)

      if (response.Code === 200) {
        setTokenBack(response.Message)
        setisAuthBackend(true)
        localStorage.setItem('TokenBackend', response.Message)

        const result = await ValidateStatusUser(User, response.Message)
        if (result.Code === 200) {
          if (result.Data.UserB2CStatus === '0') {
            const mensaje = `Su usuario se encuentra inactivo, contáctese con el administrador del aplicativo.`
            Swal.fire({
              title: `Sin Acceso`,
              text: `${mensaje}`,
              icon: 'info',
              confirmButtonColor: '#28a745',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Entendido',
              allowOutsideClick: false,
              footer:
                '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
            }).then((result) => {
              if (result.isConfirmed) {
                setisAuthBackend(false)
                localStorage.removeItem('accessToken')
                localStorage.removeItem('TokenBackend')

                window.location.replace(`${urlfront}`)
              }
            })
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(async () => {
    try {
      let user
      let userIFI

      setIsLoading(true)
      if (stateQueryParamAT === null) {
        setIsLoading(false)
        if (TokenIFI[1] !== undefined) {
          window.sessionStorage.setItem('sessionpathname', pathname)
          localStorage.setItem('accessToken', TokenIFI[1])
          userIFI = authServiceIFI.getUserInfo(TokenIFI[1])
          if (userIFI.extension_IdUserType === 2) {
            setIsAuthenticated(true)
            setUserName(userIFI.extension_IFIUser)
            setUserFullName(
              userIFI.extension_Name + '' + userIFI.extension_LastName,
            )
            setUserID2C(userIFI.sub)

            setUserRoles('IFI')

            setUserID(userIFI.sub)
            setIdIFIToken(userIFI.extension_IdIFI)
            setUserCountry(userIFI.extension_IdCountry)
            getAuth(userIFI.extension_Email, userIFI.sub)
          } else {
            const mensaje = `Usuario no cuenta con Perfil necesario para realizar gestiones en el aplicativo Cambio II.`
            Swal.fire({
              title: `Sin Acceso`,
              text: `${mensaje}`,
              icon: 'info',
              confirmButtonColor: '#28a745',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Entendido',
              allowOutsideClick: false,
              footer:
                '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
            }).then((result) => {
              if (result.isConfirmed) {
                setisAuthBackend(false)
                localStorage.removeItem('accessToken')
                localStorage.removeItem('TokenBackend')

                window.location.replace(`${urlfront}`)
              }
            })
          }
        }
      } else {
        if (stateQueryParamAT) {
          await ValidateTokenMipyme(stateQueryParamAT).then((res) => {
            if (res.Data.IsValid) {
              window.sessionStorage.setItem('sessionpathname', pathname)
              localStorage.setItem('accessToken', stateQueryParamAT)
              user = authService.getUserInfo(stateQueryParamAT)
              setIsAuthenticated(true)
              setUserName(user.userName)
              setUserFullName(user.userFullName)
              // setUserRoles([user.Role])
              setUserRoles('MIPYME')
              setUserCompanyID(user.companyId)
              setUserCompanyName(user.companyName)
              setUserCompanyType(user.companyType)
              setUserID(user.idUserAzureB2C)
              setUserCountry(user.idCountry)
              // toDo quitar esto
              setUserID2C(user.idUserAzureB2C)
              setTokenBack(stateQueryParamAT)
              setisAuthBackend(true)
              localStorage.setItem('TokenBackend', stateQueryParamAT)
            } else {
              swal({
                title: 'Error',
                text: 'El enlace de acceso no es válido o se encuentra expirado, solicite uno nuevo.',
                icon: 'error',
                buttons: {
                  catch: {
                    text: 'Entendido',
                    value: 'catch',
                  },
                },
              }).then((value) => {
                switch (value) {
                  case 'catch':
                    localStorage.removeItem('accessToken')
                    localStorage.removeItem('TokenBackend')
                    setIsAuthenticated(false)
                    swal.close()
                    break
                  default:
                    swal.close()
                }
              })
            }
          })
        }
      }
    } catch (error) {
      console.error('TODO: Handle me properly test', { error })
    } finally {
      setIsLoading(false)
    }
  }, [])

  const logoutSession = () => {
    // authService.logout()

    localStorage.removeItem('accessToken')
    localStorage.removeItem('TokenBackend')
    setIsAuthenticated(false)
  }

  return (
    <AuthContext.Provider
      value={{
        userName,
        userFullName,
        userCompanyID,
        userCompanyName,
        userCompanyType,
        userCountry,
        isAuthenticated,
        isLoading,
        login: authService.login,
        logout: logoutSession,
        loginCallback: authService.loginCallback,
        userID,
        userToken,
        UserRoles,
        setUserToken,
        // canReadAllProjects,
        registration: authService.registration,
        // ESTAS SON PARA EL LOGIN DE IFIS
        setIsAuthenticated,
        setUserRoles,
        setUserID,
        setIsLoading,
        setOpenFake,
        userIDB2C,
        setUserID2C,
        IdIFIToken,
        setIdIFIToken,
        TokenBack,
        setTokenBack,
        isAuthBackend,
        setisAuthBackend,
      }}
    >
      {/* <div
        style={{
          background: '#f3f3f3',
          color: '#fff',
          position: 'fixed',
          bottom: 0,
          right: 0,
          padding: 15,
          zIndex: 9999,
        }}
      >
        {!isAuthenticated ? (
          !openFake ? (
            <Button onClick={() => setOpenFake(true)}>Fake Login</Button>
          ) : (
            <Button onClick={() => setOpenFake(false)}>Close</Button>
          )
        ) : (
          <Button onClick={() => setIsAuthenticated(!isAuthenticated)}>
            Logout
          </Button>
        )}
        {openFake ? (
          <div style={{ display: 'flex' }}>
            <input
              onChange={(e) => setUserName(e.target.value)}
              value={userName}
              placeholder="Usuario"
            />
            <Button
              onClick={() => {
                window.sessionStorage.setItem('sessionpathname', pathname)
                setUserRoles(['MIPYME'])
                setUserToken('testtoken')
                setUserID('123')
                setIsLoading(false)
                setIsAuthenticated(true)
                setOpenFake(false)
                getAuth('DEV')
              }}
              style={{ marginLeft: 10 }}
            >
              Login
            </Button>
          </div>
        ) : null}
      </div> */}
      {children}
    </AuthContext.Provider>
  )
}
AuthContextProvider.propTypes = {
  children: PropTypes.node,
}
export const useAuthentication = () => {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('useUser can only be used inside UserProvider')
  }
  return context
}
